import "@/less/themes/default.less";
import "@/less/themes/colorblind.less";

export const DEFAULT_THEME = "default";
export const COLORBLIND_THEME = "colorblind";
export const AVAILABLE_THEMES = [DEFAULT_THEME, COLORBLIND_THEME];

export const DEFAULT_FONT = "RubikVariable";
export const OPENDYSLEXIC_FONT = "OpenDyslexic";
export const AVAILABLE_FONTS = [DEFAULT_FONT, OPENDYSLEXIC_FONT];

/**
 * @param {string} theme
 * @returns {string}
 */
export function getValidOrDefaultTheme(theme) {
  if (AVAILABLE_THEMES.includes(theme)) {
    return theme;
  }

  return DEFAULT_THEME;
}

/**
 * @param {string} theme
 */
export function applyTheme(theme) {
  document.querySelector(":root").setAttribute("data-theme", getValidOrDefaultTheme(theme));
}
